import { create } from 'zustand';

interface AnswerModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useAnswerModal = create<AnswerModalStore>(set => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useAnswerModal;
